import React from 'react';
import { Link } from 'react-router-dom';
import site from '../../site.json';

// Shared footer for refreshed boards (RefugeeJobLeads design, 2026-10-02): a dark band in the board's `ink`. The email address is shown as
// text, not a mailto link (owner: no mailto buttons).
export default function ModernFooter({ logo }) {
  return (
    <footer className="bg-ink text-white/75">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-5 py-10 sm:flex-row sm:items-center">
        <Link to="/" className="flex items-center gap-2">
          {logo}
          <span className="font-[Poppins] text-2xl font-bold text-white">{site.name}</span>
        </Link>
        <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm sm:ml-8">
          <Link to="/jobs" className="hover:text-white">Job postings</Link>
          <Link to="/about" className="hover:text-white">About</Link>
          <Link to="/terms-and-conditions" className="hover:text-white">Terms &amp; Conditions</Link>
        </nav>
        <p className="text-sm sm:ml-auto">
          Questions? <span className="select-all font-semibold text-white">enquiries@canadajobleads.ca</span>
        </p>
      </div>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-6xl px-5 py-4 text-xs text-white/60">
          © {new Date().getFullYear()} {site.name}.ca, a Vinara Software Co. product
        </p>
      </div>
    </footer>
  );
}

